import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)


export default {
    namespaced:true,
    state: {
  
      users:null,
      token: null,
      idTrabajador : null,
    },
    getters: {
        Users(state){
            return state.users
        },

        Tokens(state){
            return state.token
        },

        IdTrabajador(state){
          return state.idTrabajador
        },

    
    },
    mutations: {
      llenarUser(state,data){
        state.users = data
      },
  
      llenarToken(state,data){
        state.token = data
      },

      llenarIdTrabajador(state,data){
        state.idTrabajador = data
      },

    
    },

    
    actions: {
    async  login({commit}, user){
      await  axios.post("Autentication/LoginBI",
          user
        )
        .then( datos => {
          console.log(datos.data);
          if(datos.data.token){
            this.spinner = true
            this.boton = false
          
          const authToken = datos.data.token;
          const authUser = datos.data.userId;
          const authIdTrabajador = datos.data.idTrabajdor
          const idSolxPostulante = datos.data.idSolxPostulante
          const idPerfil = datos.data.idPerfil
          const idConta = datos.data.idContacto
          // const tiempoExpirado = datos.data.config.validTo
          localStorage.setItem("access_token", authToken);
          localStorage.setItem("userId", authUser);
          localStorage.setItem('idTrabajdor', authIdTrabajador)
          localStorage.setItem('idSolxPostulante', idSolxPostulante)
          localStorage.setItem('idPerfil', idPerfil)
          localStorage.setItem('idContacto' , idConta)
          
          commit("llenarUser",datos.data.userId)
          commit("llenarToken",datos.data.token)
          commit('llenarIdTrabajador', datos.data.idTrabajdor)
          // localStorage.setItem("tiempoCaducado", tiempoExpirado.slice(11,19))
          window.location.reload(true);
  
          }
      
        }).catch(error =>{
             
          // Si el backend responde 401, el mensaje está en error.response.data.mensaje
        let mensajeError = "Error de conexión con el servidor";

        if (error.response && error.response.data && error.response.data.mensaje) {
          mensajeError = error.response.data.mensaje;
        }

        console.error("Error en login:", mensajeError);
        
        // Re-lanzamos el error para que el componente (.vue) pueda mostrar la alerta
        throw mensajeError;
        });
      }
      
  
         
      
    },
    modules: {
    }
  }
  